/**
 * API Client for Products Search (Remake → Produkt-Brücke).
 *
 * Wraps GET /api/v2/products/search.
 * Backend route returns { matches, matched_field }. matched_field is one of
 * 'sku' | 'gtin' | 'asin' for an exact identifier hit, 'like' for a
 * substring fallback over name + identifier fields, or null when nothing
 * matched.
 */
import { apiClient } from '@/lib/api-client'

export type ProductSearchType = 'auto' | 'sku' | 'gtin' | 'asin'
export type MatchedField = 'sku' | 'gtin' | 'asin' | 'like' | null

export interface ProductSearchMatch {
  id: string
  name: string
  sku: string | null
  gtin: string | null
  asin: string | null
  workspace_integration_id: string | null
}

export interface ProductSearchResult {
  matches: ProductSearchMatch[]
  matched_field: MatchedField
}

export async function searchProducts(params: {
  identifier: string
  type?: ProductSearchType
}): Promise<ProductSearchResult> {
  const resp = await apiClient.get<ProductSearchResult>('/api/v2/products/search', {
    params: { identifier: params.identifier, type: params.type ?? 'auto' },
  })
  return resp.data
}
